export const toBoolean = (data: string): boolean => {
  return data.toLowerCase() === 'true';
};
